
<div
  v-if="isReady"
  id="register-app"
  :style="{
    backgroundImage: `url(${backgroundContent.backgroundImage})`,
    display: viewType,
  }"
  :class="{
    'register-mobile': isMobile,
    'register-wpsoffice': isWpsoffice,
  }"
>
  <Header v-if="headerShow" />
  <template v-if="$initRouteVueMode">
    <router-view v-show="contentShow" />
  </template>
  <component v-else v-show="!loadingShow" :is="targetComponent" />
  <div v-if="spinShow" class="mask">
    <Spin :class="$style['spin']" size="large" :tip="$t('093fa0fb74')" />
  </div>
  <PCLogin />
  <Spin v-if="loadingShow" :id="$style['loading-wrap']" size="large" />
  <SwitchAccount></SwitchAccount>
</div>
